import React from 'react';
import PropTypes from 'prop-types';
import { usePromptHint } from 'Components/UI/Meta/MetaControl/Types/usePromptHint';
import HelperText from '../HelperText';
import { getValue } from '../utils';

function Bool({
  attrName,
  onChange,
  onInlineSubmit,
  metaField,
  resource,
  CustomProps,
  SpreadProps,
  HelperProps,
  ...rest
}) {
  async function handleChange(value) {
    // To support the older checkbox interface that expects e.target.checked, we want to check the passed in value
    // and use e.target.checked if it exists. Otherwise, take what you were provided
    let updatedValue = value?.target?.checked?.toString();
    if (updatedValue === undefined) {
      updatedValue = value.toString();
    }

    if (onInlineSubmit) {
      await onChange(updatedValue);
      onInlineSubmit(updatedValue, [attrName, updatedValue]);
    } else {
      await onChange(updatedValue);
    }
  }

  const Component = metaField.attr('_component');
  const { label } = usePromptHint(metaField);

  const value = getValue(resource, metaField, attrName,
    {
      formatValue: (v => v === 'true'),
      formatReadOnly: (v => (v === 'true' ? 'True' : 'False')),
      defaultValue: false,
    });


  return (
    <Component
      helperText={
        <HelperText
          metaField={metaField}
          {...HelperProps}
        />
      }
      helperTextValue={HelperProps.helperText}
      hidden={metaField.attr('hidden')}
      default={metaField.attr('default')}
      label={label}
      readonly={metaField.attr('readonly')}
      value={value}
      onChange={async val => handleChange(val)}
      required={metaField.attr('required')}
      {...SpreadProps}
      {...CustomProps}
      {...rest}
    />
  );
}

Bool.defaultProps = {
  onInlineSubmit: null,
  HelperProps: {},
};

Bool.propTypes = {
  attrName: PropTypes.string.isRequired,
  metaField: PropTypes.object.isRequired,
  onInlineSubmit: PropTypes.func,
  resource: PropTypes.object.isRequired,
  HelperProps: PropTypes.object,
};

export default Bool;
